import { Box ,Stack} from "@mui/material";
import { useState } from "react";
import UploadSidePanel from "./UploadSidePanel";
import UploadViewerPanel from "./UploadViewerPanel";

export default function DocumentUploadPage({
  defaultLocation,
  defaultControls = [],
  onUploadSuccess
}) {
  const [location, setLocation] = useState(defaultLocation || "");
  // const [controls, setControls] = useState(
  //   defaultControls.length
  //     ? defaultControls.map((c, idx) => ({
  //         id: idx + 1,
  //         controlNo: c.controlNo,
  //         docType: c.defaultDocType
  //           ? { abbrevation: c.defaultDocType }
  //           : null,
  //         allowedDocTypes: c.allowedDocTypes || [],
  //         lockDocType: c.lockDocType,
  //         files: []
  //       }))
  //     : [{ id: 1, controlNo: "", docType: null, files: [] }]
  // );

  // const [selectedFile, setSelectedFile] = useState(null);
  // const [uploadStatus, setUploadStatus] = useState(null);
  // const [activeControlId, setActiveControlId] = useState(
  //   controls[0]?.id
  // );
  const [controls, setControls] = useState(
    defaultControls.length
      ? defaultControls.map((c, idx) => ({
          id: idx + 1,
          controlNo: c.controlNo,
          docType: c.defaultDocType
            ? {
                id: c.defaultDocType.id,
                code: c.defaultDocType.code,
                abbrevation: c.defaultDocType.abbrevation
              }
            : null,
          allowedDocTypes: c.allowedDocTypes || [],
          lockDocType: c.lockDocType,
          lockControlNo: c.lockControlNo,
          files: []
        }))
      : [{ id: 1, controlNo: "", docType: null, files: [] }]
  );
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadStatus, setUploadStatus] = useState(null);
  const [activeControlId, setActiveControlId] = useState(
    controls[0]?.id
  );

  return (
    <Box
      sx={{
        height: "100vh",
        width: "100vw",
        backgroundColor: "#fff",
        display: "flex" 
      }}
    >
      {/* LEFT PANEL */}
      <UploadSidePanel
        location={location}
        setLocation={setLocation}
        controls={controls}
        setControls={setControls}
        activeControlId={activeControlId}
        setActiveControlId={setActiveControlId}
        setSelectedFile={setSelectedFile}
        selectedFile={selectedFile}
        setUploadStatus={setUploadStatus}
        onUploadSuccess={onUploadSuccess}
      />

      {/* RIGHT PANEL */}
      <UploadViewerPanel
        selectedFile={selectedFile}
        uploadStatus={uploadStatus}
      />
    </Box>
  );
}
